<div class="views-list-dialog h-full flex flex-col bg-white">
  <!-- Dialog Header -->
  <div class="dialog-header px-6 py-5 border-b border-gray-100 flex items-center justify-between">
    <div>
      <h3 class="text-xl font-semibold m-0">Saved Views</h3>
      <p class="text-sm text-gray-500 mt-1">Select a view or create a new one</p>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="close()"
      class="text-gray-400 hover:text-gray-600 transition-colors">
      <mat-icon svgIcon="c:x"></mat-icon>
    </button>
  </div>

  <!-- Search Bar -->
  <div class="px-6 py-4">
    <div class="relative">
      <mat-icon class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" svgIcon="c:search"></mat-icon>
      <input
        type="text"
        placeholder="Search views..."
        class="w-full pl-10 pr-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-[var(--color-action)] transition-colors bg-white"
        [(ngModel)]="searchText"
        (input)="filterViews()">
      </div>
    </div>
    <!-- Dialog Content -->
    <div class="dialog-content flex-1 overflow-y-auto px-6 pb-4">
      <!-- Skeleton Loader -->
      @if (isLoading) {
        <div class="space-y-4">
          @for (i of [1, 2, 3]; track i) {
            <div class="view-section mb-5">
              <div class="category-header mb-2 flex items-center justify-between px-3 py-1.5 rounded bg-gray-100 animate-pulse">
                <div class="h-3 bg-gray-300 rounded w-32"></div>
                <div class="h-5 w-8 bg-gray-300 rounded-full"></div>
              </div>
              <div class="view-list space-y-2">
                @for (j of [1, 2, 3]; track j) {
                  <div class="w-full px-4 py-3 border rounded-lg bg-gray-50 animate-pulse">
                    <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- Error State -->
      @if (!isLoading && hasError) {
        <div class="text-center py-12">
          <mat-icon class="text-red-400 !text-3xl !w-8 !h-8 mb-2" svgIcon="c:danger-circle"></mat-icon>
          <p class="text-sm text-red-500 mb-1">Failed to load saved views</p>
          <p class="text-xs text-gray-400">Please close this dialog and try again.</p>
        </div>
      }

      <!-- Actual Content -->
      @if (!isLoading && !hasError && hasAnyViews()) {
        <div>
          <!-- Colobbo Provided Section -->
          @if (getCategoryCount('colobboProvided') > 0) {
            <div class="view-section mb-5">
              <div class="category-header mb-2 flex items-center justify-between px-3 py-1.5 rounded bg-[var(--color-selected-bg)]">
                <span class="text-[11px] font-bold uppercase tracking-wider text-[var(--color-action)]">Colobbo Provided</span>
                <span class="text-[11px] font-bold text-gray-600 bg-white px-2 py-0.5 rounded-full shadow-sm">{{ getCategoryCount('colobboProvided') }}</span>
              </div>
              <div class="view-list space-y-2" cdkDropList (cdkDropListDropped)="onDrop($event, 'colobboProvided')">
                @for (view of filteredCategorizedViews.colobboProvided; track view) {
                  <div
                    class="view-item-wrapper">
                    <button
                      class="view-item w-full text-left px-4 py-3 text-sm border rounded-lg transition-all flex items-center justify-between group bg-white"
                      (click)="selectView(view)">
                      <span class="font-medium text-gray-700" [class.text-[var(--color-action)]]="isActiveView(view)">{{ view.name }}</span>
                      <div class="flex items-center gap-2">
                        @if (isActiveView(view)) {
                          <div class="flex items-center gap-1.5 text-[var(--color-action)]">
                            <span class="text-xs font-medium">Active</span>
                            <mat-icon class="text-base" svgIcon="c:check"></mat-icon>
                          </div>
                        }
                      </div>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
          <!-- Admin Promoted Section -->
          <!-- <div class="view-section mb-5" *ngIf="getCategoryCount('adminPromoted') > 0">
          <div class="category-header mb-2 flex items-center justify-between px-3 py-1.5 rounded bg-[var(--color-selected-bg)]">
            <span class="text-[11px] font-bold uppercase tracking-wider text-[var(--color-action)]">Admin Promoted</span>
            <span class="text-[11px] font-bold text-gray-600 bg-white px-2 py-0.5 rounded-full shadow-sm">{{ getCategoryCount('adminPromoted') }}</span>
          </div>
          <div class="view-list space-y-2" cdkDropList (cdkDropListDropped)="onDrop($event, 'adminPromoted')">
            <div
              *ngFor="let view of filteredCategorizedViews.adminPromoted"
              class="view-item-wrapper">
              <button
                class="view-item w-full text-left px-4 py-3 text-sm border rounded-lg transition-all flex items-center justify-between group bg-white"
                (click)="selectView(view)">
                <span class="font-medium text-gray-700" [class.text-[var(--color-action)]]="isActiveView(view)">{{ view.name }}</span>
                <div class="flex items-center gap-2">
                  <div *ngIf="isActiveView(view)" class="flex items-center gap-1.5 text-[var(--color-action)]">
                    <span class="text-xs font-medium">Active</span>
                    <mat-icon class="text-base" svgIcon="c:check"></mat-icon>
                  </div>
                  <button
                    *ngIf="canDeleteView(view) && !isActiveView(view)"
                    mat-icon-button
                    class="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                    (click)="deleteView($event, view)">
                    <mat-icon class="text-base" svgIcon="c:x"></mat-icon>
                  </button>
                </div>
              </button>
            </div>
          </div>
        </div> -->
        <!-- Created by Me Section -->
        @if (getCategoryCount('createdByMe') > 0) {
          <div class="view-section mb-5">
            <div class="category-header mb-2 flex items-center justify-between px-3 py-1.5 rounded bg-[var(--color-selected-bg)]">
              <span class="text-[11px] font-bold uppercase tracking-wider text-[var(--color-action)]">Created by Me</span>
              <span class="text-[11px] font-bold text-gray-600 bg-white px-2 py-0.5 rounded-full shadow-sm">{{ getCategoryCount('createdByMe') }}</span>
            </div>
            <div class="view-list space-y-2" cdkDropList (cdkDropListDropped)="onDrop($event, 'createdByMe')">
              @for (view of filteredCategorizedViews.createdByMe; track view) {
                <div
                  class="view-item-wrapper">
                  <button
                    class="view-item w-full text-left px-4 py-3 text-sm border rounded-lg transition-all flex items-center justify-between group bg-white"
                    (click)="selectView(view)">
                    <span class="font-medium text-gray-700" [class.text-[var(--color-action)]]="isActiveView(view)">{{ view.name }}</span>
                    <div class="flex items-center gap-2">
                      @if (isActiveView(view)) {
                        <div class="flex items-center gap-1.5 text-[var(--color-action)]">
                          <span class="text-xs font-medium">Active</span>
                          <mat-icon class="text-base" svgIcon="c:check"></mat-icon>
                        </div>
                      }
                    </div>
                  </button>
                </div>
              }
            </div>
          </div>
        }
        <!-- Created by Others Section -->
        @if (getCategoryCount('createdByOthers') > 0) {
          <div class="view-section mb-5">
            <div class="category-header mb-2 flex items-center justify-between px-3 py-1.5 rounded bg-[var(--color-selected-bg)]">
              <span class="text-[11px] font-bold uppercase tracking-wider text-[var(--color-action)]">Created by Others</span>
              <span class="text-[11px] font-bold text-gray-600 bg-white px-2 py-0.5 rounded-full shadow-sm">{{ getCategoryCount('createdByOthers') }}</span>
            </div>
            <div class="view-list space-y-2" cdkDropList (cdkDropListDropped)="onDrop($event, 'createdByOthers')">
              @for (view of filteredCategorizedViews.createdByOthers; track view) {
                <div
                  class="view-item-wrapper">
                  <button
                    class="view-item w-full text-left px-4 py-3 text-sm border rounded-lg transition-all flex items-center justify-between group bg-white"
                    (click)="selectView(view)">
                    <span class="font-medium text-gray-700" [class.text-[var(--color-action)]]="isActiveView(view)">{{ view.name }}</span>
                    <div class="flex items-center gap-2">
                      @if (isActiveView(view)) {
                        <div class="flex items-center gap-1.5 text-[var(--color-action)]">
                          <span class="text-xs font-medium">Active</span>
                          <mat-icon class="text-base" svgIcon="c:check"></mat-icon>
                        </div>
                      }
                    </div>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    <!-- Empty State -->
    @if (!isLoading && !hasError && !hasAnyViews()) {
      <div class="text-center py-12">
        <p class="text-sm text-gray-500 mb-1">No saved views yet</p>
        <p class="text-xs text-gray-400">Create your first view to get started</p>
      </div>
    }
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer border-t border-gray-200 px-6 py-4">
    <button
      mat-flat-button
      color="primary"
      class="w-full py-2.5 rounded-md shadow-none hover:shadow-sm"
      style="background-color: var(--color-action); color: white;"
      (click)="createNewView()">
      <span>Create new view</span>
    </button>
  </div>
</div>
